import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/os/OS";
import * as React from 'react';
export default {
  Content,
  React
};